import { render, staticRenderFns } from "./DownloadManager.vue?vue&type=template&id=8ffbd0ec"
import script from "./DownloadManager.vue?vue&type=script&lang=ts"
export * from "./DownloadManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports